import { render, staticRenderFns } from "./CustomFieldData.vue?vue&type=template&id=292d6039&"
import script from "./CustomFieldData.vue?vue&type=script&lang=js&"
export * from "./CustomFieldData.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports